import React from "react";
import PropTypes from "prop-types";

import CircularProgress from "@material-ui/core/CircularProgress";
import { MarkAsToWatch } from "./markAsToWatch";
import { WatchedContent } from "./watchedContent";
import {
  UNASSIGNED,
  ASSIGNED,
  COMPLETED,
} from "../../consts/assignedContentStatus";

export const HandleAssignContent = ({ statusId, contentId }) => {
  switch (statusId) {
    case UNASSIGNED:
      return <MarkAsToWatch contentId={contentId} />;
    case ASSIGNED:
    case COMPLETED:
      return <WatchedContent statusId={statusId} contentId={contentId} />;
    default:
      return <CircularProgress />;
  }
};

HandleAssignContent.propTypes = {
  statusId: PropTypes.number,
  contentId: PropTypes.number,
};

HandleAssignContent.defaultProps = {
  statusId: 0,
  contentId: 0,
};
